var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_bulk_game",
    "data-name": "vuesax/bulk/game",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.998,
    height: 23.998,
    viewBox: "0 0 23.998 23.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "game"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20,5.35v5.58a5.356,5.356,0,0,1-5.35,5.35H5.35A5.356,5.356,0,0,1,0,10.929V5.35A5.356,5.356,0,0,1,5.35,0h9.3A5.356,5.356,0,0,1,20,5.35Z",
    transform: "translate(2 5.72)",
    fill: "#97d700",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.357,3.3l-1.03-1.03.99-.99A.749.749,0,0,0,3.257.217l-.99.99-.96-.96a.749.749,0,0,0-1.06,1.06l.96.96-.99.99a.754.754,0,0,0,0,1.06.748.748,0,0,0,1.06,0l.99-.99L3.3,4.357a.748.748,0,0,0,1.06,0A.754.754,0,0,0,4.357,3.3Z",
    transform: "translate(5.772 11.712)",
    fill: "#97d700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M1.01,2A1.011,1.011,0,0,1,0,1,.994.994,0,0,1,.99,0h.02a1,1,0,0,1,0,2Z",
    transform: "translate(12.529 12.999)",
    fill: "#97d700",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M1.01,2A1.011,1.011,0,0,1,0,1,.994.994,0,0,1,.99,0h.02a1,1,0,0,1,0,2Z",
    transform: "translate(16.469 12.999)",
    fill: "#97d700",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M1,2.01a.994.994,0,0,1-1-.99V1A1,1,0,1,1,1,2.01Z",
    transform: "translate(14.499 14.959)",
    fill: "#97d700",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M1,2.01a.994.994,0,0,1-1-.99V1A1,1,0,1,1,1,2.01Z",
    transform: "translate(14.499 11.019)",
    fill: "#97d700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M3.28.71l-.01.94A1.639,1.639,0,0,1,1.64,3.26a.223.223,0,0,0-.24.23.226.226,0,0,0,.23.23H.02a1.606,1.606,0,0,1,1.6-1.86.232.232,0,0,0,.25-.23L1.88.69A.707.707,0,0,1,2.58,0h.01A.7.7,0,0,1,3.28.71Z",
    transform: "translate(10.359 2)",
    fill: "#97d700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsports);
export default __webpack_public_path__ + "static/media/esports.a1bb84e40fe3357429cd7f9b8377980e.svg";
export { ForwardRef as ReactComponent };